import React from 'react';
import { take } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';
import { IBAN_TYPE_PERSONNAL } from '../../../services/account/iban/constants';

import { hideModal } from '../../../services/modal/actions';
import { fetchIbanIfNeeded } from '../../../services/account/iban/actions';
import { logoutUser } from '../../../services/authentication/logout/actions';
import { sendDisenrollmentRequest } from '../../../services/disenrollment/actions';

import { formatAmountCurrency } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import { getWaitingAmount } from '../../../services/account/gains/selector';
import { getValidatedAmount } from '../../../services/account/gains/selector';
import { getOnGoingPaidAmount } from '../../../services/account/paymentrequest/ongoing/selector';

import SvgComponent from '../../SvgComponent';
import ButtonComponent from '../../button/ButtonComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';
import IbanFormComponent from '../../pages/account/myprofile/IbanFormComponent';

import './DisenrolModalComponent.scss';

class DisenrolModalComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showForm: false
        };
    }

    componentDidMount() {
        this.props.fetchIbanIfNeeded();
    }

    submit = () => {
        const { sendDisenrollmentRequest, logoutUser } = this.props;

        sendDisenrollmentRequest(() => {
            logoutUser();
        });
    };

    handleAbort = () => {
        const { history, hideModal } = this.props;

        history.push(PATH.HOME_PATH);
        hideModal();
    };

    renderIbanLabel = iban => {
        const { i18nIban } = this.props;

        if (iban.label) {
            return iban.label;
        } else if (iban.firstname || iban.lastname) {
            const name = `${iban.firstname ? iban.firstname : ''} ${
                iban.lastname ? iban.lastname : ''
            }`;
            return convertHtmlToReactDomWithParams(i18nIban.ACCOUNT_OF, name);
        } else {
            return iban.iban;
        }
    };

    handleClick = () => {
        this.setState({
            showForm: !this.state.showForm
        });
    };

    handleKeyDown = e => {
        if (e.key === 'Enter') {
            this.handleClick();
        }
    };

    render() {
        const {
            i18n,
            i18nIban,
            validatedAmount,
            waitingAmount,
            paymentRequestTotalAmount,
            requestSubmit,
            errorMessage,
            successDisenrollmentRequestSubmit,
            iban,
            ibansFetching
        } = this.props;

        const validatedMinusPaymentRequest = validatedAmount - paymentRequestTotalAmount;

        return (
            <React.Fragment>
                {!successDisenrollmentRequestSubmit ? (
                    <div className="modal-disenrol">
                        <div className="container-header">{i18n.STEP1.HEADER}</div>
                        <div className="container-body">
                            <p className="title">{i18n.STEP1.TEXT1}</p>
                            <div className="cashback-wrapper">
                                {waitingAmount > 0 && (
                                    <div className="cashback waiting">
                                        <span>
                                            <SvgComponent
                                                src={`${STATIC_ROOT}/lost.svg`}
                                                width="20"
                                                height="20"
                                                aria-hidden="true"
                                                focusable="false"
                                            />
                                        </span>
                                        {convertHtmlToReactDomWithParams(
                                            i18n.STEP1.CASHBACK_WAITING,
                                            formatAmountCurrency(waitingAmount)
                                        )}
                                    </div>
                                )}
                                {validatedMinusPaymentRequest > 0 && (
                                    <React.Fragment>
                                        <div className="cashback valid">
                                            <span>
                                                <SvgComponent
                                                    src={`${STATIC_ROOT}/validation.svg`}
                                                    width="15"
                                                    height="15"
                                                    aria-hidden="true"
                                                    focusable="false"
                                                />
                                            </span>
                                            {convertHtmlToReactDomWithParams(
                                                i18n.STEP1.CASHBACK_VALID,
                                                formatAmountCurrency(validatedMinusPaymentRequest)
                                            )}
                                        </div>
                                        {ibansFetching && <LoadingComponent />}
                                        {!ibansFetching &&
                                            iban &&
                                            iban.length > 0 &&
                                            iban.map((iban, i) => (
                                                <div className="iban-wrapper" key={i}>
                                                    <p className="label">
                                                        {this.renderIbanLabel(iban)}
                                                    </p>
                                                    <p>
                                                        {convertHtmlToReactDomWithParams(
                                                            i18nIban.IBAN_NUMBER,
                                                            iban.iban
                                                        )}
                                                    </p>
                                                    {iban.bic && (
                                                        <p>
                                                            {convertHtmlToReactDomWithParams(
                                                                i18nIban.BIC_CODE,
                                                                iban.bic
                                                            )}
                                                        </p>
                                                    )}
                                                </div>
                                            ))}
                                        {!ibansFetching && (!iban || iban.length === 0) && (
                                            <React.Fragment>
                                                <div className="account-button">
                                                    <span
                                                        id="add-account-button"
                                                        title={i18nIban.ADD_NEW_ACCOUNT_DISENROLL}
                                                        aria-label={
                                                            i18nIban.ADD_NEW_ACCOUNT_DISENROLL
                                                        }
                                                        role="button"
                                                        tabIndex="0"
                                                        onClick={this.handleClick}
                                                        onKeyDown={this.handleKeyDown}>
                                                        <span className="plus">+</span>
                                                        <span className="text">
                                                            {i18nIban.ADD_NEW_ACCOUNT_DISENROLL}
                                                        </span>
                                                    </span>
                                                </div>
                                                {this.state.showForm && (
                                                    <React.Fragment>
                                                        <p className="new-account">
                                                            {i18nIban.NEW_ACCOUNT}
                                                        </p>
                                                        <IbanFormComponent
                                                            type={IBAN_TYPE_PERSONNAL}
                                                        />
                                                    </React.Fragment>
                                                )}
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                )}
                                <div className="cashback">{i18n.STEP1.TEXT2}</div>
                            </div>
                        </div>
                        <div className="container-button">
                            <ButtonComponent
                                id="disenroll-abort"
                                color="second"
                                text={i18n.STEP1.CTA_ABORT}
                                onClick={this.handleAbort}
                            />
                            <ButtonComponent
                                color="main"
                                text={i18n.STEP1.CTA_CONFIRM}
                                onClick={this.submit}
                            />
                        </div>
                        <div className="submit-container">
                            {requestSubmit && <LoadingComponent />}
                            {errorMessage && <p className="color-err">{errorMessage}</p>}
                        </div>
                    </div>
                ) : (
                    <div className="modal-disenrol-confirm">
                        <div className="container-body">
                            <span>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/validation.svg`}
                                    width="50"
                                    height="40"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                            </span>
                            <p className="title">{i18n.STEP2.TEXT1}</p>
                            <p>{i18n.STEP2.TEXT2}</p>
                            <p>{i18n.STEP2.TEXT3}</p>
                        </div>
                        <div className="container-button">
                            <ButtonComponent
                                id="disenrolled-ok"
                                color="main"
                                text={i18n.STEP2.CTA_OK}
                                onClick={this.handleAbort}
                            />
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

DisenrolModalComponent.propTypes = {
    i18n: PropTypes.object
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    const ibans = state.account.iban.ibans;
    const ibanFromApi = take(
        ibans
            .filter(iban => iban.type === IBAN_TYPE_PERSONNAL && iban.fromApi)
            .sort((a, b) => b.id - a.id),
        1
    );
    const ibanByHand = take(
        ibans
            .filter(iban => iban.type === IBAN_TYPE_PERSONNAL && !iban.fromApi)
            .sort((a, b) => b.id - a.id),
        1
    );
    const iban =
        ibanFromApi && ibanFromApi.length > 0
            ? ibanFromApi
            : ibanByHand && ibanByHand.length > 0
            ? ibanByHand
            : [];

    return {
        validatedAmount: getValidatedAmount(state),
        waitingAmount: getWaitingAmount(state),
        paymentRequestTotalAmount: getOnGoingPaidAmount(state),
        i18n: state.i18n.page.DISENROLLMENT_MODAL,
        i18nIban: state.i18n.page.ACCOUNT.PROFILE.IBAN,
        errorMessage: state.disenrollment.error || '',
        requestSubmit: state.disenrollment.fetching || false,
        successDisenrollmentRequestSubmit: state.disenrollment.successDisenrollmentRequestSubmit,
        pathname: state.routing.location.pathname,
        iban: iban,
        ibansFetching: state.account.iban.fetching
    };
};
const mapDispatchToProps = {
    hideModal,
    sendDisenrollmentRequest,
    logoutUser,
    fetchIbanIfNeeded
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DisenrolModalComponent));



// WEBPACK FOOTER //
// ./src/components/authentication/disenrollment/DisenrolModalComponent.js